var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_1949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 -0.000732416V47.7281C23.0719 47.7281 22.3031 47.5406 21.525 47.175C5.36721 39.4406 1.54596 22.425 1.41565 13.0406C1.48784 10.6687 3.03002 8.63625 5.09065 7.76156L22.7531 0.273093C23.1375 0.0944989 23.5688 -0.000760541 24 -0.000732416C24.0281 -0.000732416 24.0469 -0.000498041 24.0656 1.75844e-05L24 -0.000732416Z",
    fill: "#0066FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24 1.75844e-05C24.0187 -0.000498041 24.0469 -0.000732416 24.0656 -0.000732416C24.5063 -0.000760541 24.9281 0.0944989 25.3219 0.273093L42.975 7.76156C45.0375 8.63625 46.5844 10.6687 46.5656 13.0406C46.5187 22.425 42.7031 39.4406 26.5406 47.175C25.7625 47.5406 24.9188 47.7281 24.0656 47.7281V-0.000732416L24 1.75844e-05Z",
    fill: "#0066FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_1949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7a973ccae133c4d0db0d1461f8ce8502.svg";
export { ForwardRef as ReactComponent };